var render = function render(){var _vm=this,_c=_vm._self._c;return _c('base-header',[_c('ConsoleMenu'),_c('div',{attrs:{"slot":"right"},slot:"right"},[_c('gallery-columns-dialog')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }